import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import styled from '@emotion/styled'
import SkillCard from './ContactoCard'
import { Container } from '@mui/system'
import { Grid, Typography } from '@mui/material'
import MemoryIcon from '@mui/icons-material/Memory'
import { skillsList2 } from '../../data/data'
import IronIcon from '@mui/icons-material/Iron';
const ContactoContainer = styled(Container)`
  text-align: center;
  margin: 100px 0 100px 0;
	padding-top: 100px;
`

const SkillGridItem = styled(Grid)`
  display: flex;
  justify-content: center;
  align-content: center;
`

const Contacto = () => {
  return (
    <ContactoContainer id="Contacto-Container">
      <IronIcon sx={{ fontSize: 40 }} />
      <Typography variant="h1" sx={{ marginBottom: 2 }}>
      Contacto
      </Typography>
      
        {skillsList2.map((skill: string) => (
          <SkillGridItem item xs={12} md={6} key={uuidv4()}>
            <SkillCard skill={skill} />
          </SkillGridItem>
        ))}
     
    </ContactoContainer>
  )
}

export default Contacto



